import React from "react";

import {
  Form,
  FormElement,
  FormValidator,
  CustomTextControl,
  BaseReactComponent,
  FormSubmitButton,
} from "../../utils/form";
import { Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "../../utils/hoc/withRouter";
import { CustomModal, Spinner, SelectKeywords } from "../common";
import { addContentTypeApi, updateContentTypeApi, getKeywordNameApi } from "./Api";
import { toast } from "react-toastify";

class ContentTypeForm extends BaseReactComponent {
  constructor(props) {
    super(props);
    const data = props.editData || null;
    this.state = {
      contentTypeName: data?.contentTypeName || "",
      keywords: data?.keywords ? data.keywords.split(",").map(item => item.trim()).filter(Boolean) : [],
      keywordOption: [],
      search: "",
      isAddContent: true,
      resLoading: false,
    };
  }

  componentDidMount() {
    this.props.getKeywordNameApi(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.search !== prevState.search) {
      this.props.getKeywordNameApi(this);
    }
  }

  keywordsChangeHandler = (info) => {
    this.setState({ search: info })
  }

  onValidSubmit = () => {
    this.setState({ resLoading: true })
    const context = this.props.this || this.props.ctx;
    if (this.props.editData?.uuid) {
      let dataObj = {
        "data": {
          "keywords": this.state.keywords?.length > 0 ? this.state.keywords.join(",") : "",
        }
      };
      const data = new FormData();
      data.append("key", JSON.stringify(dataObj));
      updateContentTypeApi(data, context, this.props.onHide, this.props.editData.uuid)
        .finally(() => this.setState({ resLoading: false }));
    } else {
      let data = {
        "data": {
          "keywords": this.state.keywords?.length > 0 ? this.state.keywords.join(",") : "",
        }
      };
      addContentTypeApi(JSON.stringify(data), context, this.props.onHide)
        .finally(() => this.setState({ resLoading: false }));
    }
  };

  render() {
    const { resLoading } = this.state;
    return (
      <CustomModal
        show={this.props.show}
        onHide={this.props.onHide}
        title={this.props.editData?.uuid ? "Edit Content Type" : "Add Content Type"}
        modalClass={"change-password"}
      >
        <Form onValidSubmit={this.onValidSubmit}>
          <Row>
            <Col sm={12}>
              <FormElement
                valueLink={this.linkState(this, "contentTypeName")}
                label="Content Type Name"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Field cannot be empty",
                  },
                ]}
                control={{
                  type: CustomTextControl,
                  settings: {
                    placeholder: "Enter Content Type Name",
                    disabled: !!this.props.editData?.uuid,
                  },
                }}
              />
            </Col>
            <Col sm={12}>
              <SelectKeywords
                required={false}
                label="Keywords"
                placeholder={'Enter Keywords'}
                onchangeHandler={(data) => this.keywordsChangeHandler(data)}
                selectedKeyWords={this.state.keywords}
                options={this.state.keywordOption}
                getKeys={(data) => this.setState({ keywords: data })}
              />
            </Col>
          </Row>
          <div className="submit-wrapper" style={{ justifyContent: "center" }}>
            <FormSubmitButton customClass={"primary-btn"}>
              {resLoading ? <span className="d-flex align-items-center gap-12"> <Spinner /> Saving...</span> : "Save"}
            </FormSubmitButton>
          </div>
        </Form>
      </CustomModal>
    );
  }
}

export default connect(null, { getKeywordNameApi })(withRouter(ContentTypeForm));
